import DashboardSample from './DashboardSample'

export default DashboardSample